<template>
    <div>
        <div style="margin-bottom: 20px">
            <div flex>
                <div style="margin-right: 10px">
                    <el-input min="1" max="60" type="number" style="width: 150px" v-model="timeout" placeholder="">
                        <template slot="prepend">超时</template>
                    </el-input>
                </div>
                <div style="margin-right: 10px">
                    <el-button type="primary" @click="initClick" :loading="loading">
                        <template v-if="loading && pagination">
                            {{page}}/{{parseInt(pagination.totalCount/pagination.pageSize)}}
                        </template>
                        <template v-else>开始测试</template>
                    </el-button>
                </div>
                <div style="margin-right: 10px">
                    <el-button type="primary" @click="start = false" :disabled="!start">停止</el-button>
                </div>
            </div>
        </div>
        <el-table :data="errorList">
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <pre>{{JSON.stringify(scope.row.error, null, '    ')}}</pre>
                </template>
            </el-table-column>
            <el-table-column label="异常站点" prop="name">
                <template slot-scope="scope">
                    <div>{{scope.row.name}}</div>
                </template>
            </el-table-column>
            <el-table-column label="网址" prop="name">
                <template slot-scope="scope">
                    <div>{{scope.row.protocol}}{{scope.row.domain}}</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            start: false,
            loading: false,
            errorList: [],
            page: 0,
            timeout: 3,
            pagination: null
        }
    },
    computed: {
        reverseErrorList: function () {
            return JSON.stringify(this.errorList)
        }
    },
    methods: {
        initClick() {
            this.errorList = []
            this.start = true
            this.init()
        },
        init(page) {
            if (!this.start) {
                this.loading = false
                return
            }
            page = page || 0
            this.page = page
            this.loading = true
            axios({
                url: 'admin/host/host-test',
                params: {
                    page: page,
                    timeout: this.timeout
                }
            }).then(e => {
                if (e.data.code === 0) {
                    if (e.data.data.pagination) {
                        this.pagination = e.data.data.pagination
                    }
                    if (e.data.data.errorList && e.data.data.errorList.length) {
                        this.errorList = this.errorList.concat(e.data.data.errorList)
                    }
                    if (!e.data.data.end) {
                        this.init(e.data.data.next)
                    } else {
                        this.loading = false
                        this.start = true
                    }
                } else {
                    this.loading = false
                    this.start = true
                }
            }).catch(e => {
            })
        }
    }
}
</script>

<style scoped>

</style>
